import React, { useState, useEffect } from "react";
import { Link, NavLink, Route, Routes, useLocation } from "react-router-dom";
import Home from "./Home"
import About from "./Pages/About";
import Service from "./Pages/Services";
import Projects from "./Pages/Projects";
import WhyUs from "./Pages/Whyus";
import Contact from "./Pages/Contact";
const Header = () => {
  // State for mobile menu toggle
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false); // New state for sticky header
  const [lastScrollY, setLastScrollY] = useState(0); // State to track the last scroll position
  const location = useLocation(); // Get current page location

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Navigation links
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About Us", href: "/About" },
    { name: "Services", href: "/Service" },
    { name: "Showcase", href: "/showcase" },
    { name: "Why Us", href: "/why-us" },
    { name: "Contact Us", href: "/contact-us" },
  ];

  // Handle scroll event to toggle sticky class and detect scroll direction
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Check if scrolling down
      if (currentScrollY > 50 && currentScrollY > lastScrollY) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      // Update the last scroll position
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);
  const isHomePage = location.pathname === '/';

  return (
    <>
    <header
      className={`sticky inset-x-0 top-0 z-30 mx-auto w-full max-w-screen-md border border-gray-100 bg-white/80 py-3 shadow backdrop-blur-lg  md:rounded-3xl
        ${ isSticky ? "bg-white md:top-0 shadow-lg lg:max-w-screen-2xl" : "lg:max-w-screen-lg md:top-6"} transition-all duration-300 ease-in-out
        ${isHomePage? '' : 'lg:max-w-screen-xl md:top-1'}
        `}
    >
      <div className="px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex shrink-0">
            <a aria-current="page" className="flex items-center" href="/">
              <img
                className="h-12 w-auto"
                src="../images/logos/header-logo.png"
                alt="Best+online+website+development+agency"
              />
              <p className="sr-only">Wekeon</p>
            </a>
          </div>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex md:items-center md:justify-center gap-2 lg:gap-5">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.href}
                className={({ isActive }) =>
                  `inline-block rounded-lg px-2 py-1 text-[12px] lg:text-sm font-medium text-gray-900 transition-all duration-200 ${isActive ? 'bg-gray-200' : 'hover:bg-gray-100'}`
                }
                exact
              >
                {link.name}
              </NavLink>

            ))}
          </div>

          {/* Desktop Sign-In / Login Buttons */}
          <div className="flex items-center justify-end gap-3">
            {/* <a
              className="hidden items-center justify-center rounded-xl bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all duration-150 hover:bg-gray-50 sm:inline-flex"
              href="/login"
            >
              Sign in
            </a>
            <a
              className="inline-flex items-center justify-center rounded-xl bg-[#175293] px-3 py-2 text-sm font-semibold text-white shadow-sm transition-all duration-150 hover:bg-[#21AA4A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              href="/login"
            >
              Login
            </a> */}

            <Link
              className="inline-flex  text-[10px] md:text-[14px] items-center uppercase justify-center rounded-xl bg-[#21AA4A] px-3 py-2 font-semibold text-white shadow-sm transition-all duration-150 hover:bg-[#000] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              to="/contact-us"
            >
              Free Consultation
            </Link>
            {/* Mobile Menu Button */}
            <div className="md:hidden flex items-center">
              {!isMenuOpen ? (
                <button onClick={toggleMenu} className="text-gray-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              ) : (
                <button onClick={toggleMenu} className="text-gray-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <div
        className={`fixed top-[62px] right-0 z-40 bg-white shadow-lg w-64 p-6 transform  transition-all duration-300 ease-in-out ${
          isMenuOpen ? "translate-x-0 opacity-100 block" : "translate-x-full hidden opacity-0"
        }`}
        style={{ transitionProperty: "transform, opacity" }}
      >
        <div className="mt-4 space-y-4">
          {navLinks.map((link) => (
            <NavLink
                key={link.name}
                to={link.href}
                onClick={() => setIsMenuOpen(false)}
              className="block px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100"
            >              
              {link.name}
           </NavLink>
          ))}
        </div>
      </div>
    </header>
    <ScrollToTop />
    <Routes>
      <Route path="/" Component={Home}/>
      <Route path="/About" Component={About}/>
      <Route path="/Service/:tabName" element={<Service />} />
      <Route path="/Service" Component={Service}/>
      <Route path="/showcase" Component={Projects}/>
      <Route path="/why-us" Component={WhyUs}/>
      <Route path="/contact-us" Component={Contact}/>

    </Routes>
    </>
  );
};
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};
export default Header;
